// Traditional Incarnation Cross names keyed by Personality Sun gate: [RightAngle, Juxtaposition, LeftAngle].
import { gateKeynote, quarterOf } from "./gates";

const C = {
  13: ["the Sphinx", "Listening", "Masks"], 49: ["Explanation", "Principles", "Revolution"],
  30: ["Contagion", "Fates", "Industry"], 55: ["the Sleeping Phoenix", "Moods", "Spirit"],
  37: ["Planning", "Bargains", "Migration"], 63: ["Consciousness", "Doubt", "Dominion"],
  22: ["Rulership", "Grace", "Informing"], 36: ["Eden", "Crisis", "the Plane"],
  25: ["the Vessel of Love", "Innocence", "Healing"], 17: ["Service", "Opinions", "Upheaval"],
  21: ["Tension", "Control", "Endeavour"], 51: ["Penetration", "Shock", "the Clarion"],
  42: ["Maya", "Completion", "Limitation"], 3: ["Laws", "Mutation", "Wishes"],
  27: ["the Unexpected", "Caring", "Alignment"], 24: ["the Four Ways", "Rationalization", "Incarnation"],
  2: ["the Sphinx", "the Driver", "Defiance"], 23: ["Explanation", "Assimilation", "Dedication"],
  8: ["Contagion", "Contribution", "Uncertainty"], 20: ["the Sleeping Phoenix", "the Now", "Duality"],
  16: ["Planning", "Experimentation", "Identification"], 35: ["Consciousness", "Experience", "Separation"],
  45: ["Rulership", "Possession", "Confrontation"], 12: ["Eden", "Articulation", "Education"],
  15: ["the Vessel of Love", "Extremes", "Prevention"], 52: ["Service", "Stillness", "Demands"],
  39: ["Tension", "Provocation", "Individualism"], 53: ["Penetration", "Beginnings", "Cycles"],
  62: ["Maya", "Detail", "Obscuration"], 56: ["Laws", "Stimulation", "Distraction"],
  31: ["the Unexpected", "Influence", "the Alpha"], 33: ["the Four Ways", "Retreat", "Refinement"],
  7: ["the Sphinx", "Interaction", "Masks"], 4: ["Explanation", "Formulization", "Revolution"],
  29: ["Contagion", "Commitment", "Industry"], 59: ["the Sleeping Phoenix", "Strategy", "Spirit"],
  40: ["Planning", "Denial", "Migration"], 64: ["Consciousness", "Confusion", "Dominion"],
  47: ["Rulership", "Oppression", "Informing"], 6: ["Eden", "Conflict", "the Plane"],
  46: ["the Vessel of Love", "Serendipity", "Healing"], 18: ["Service", "Correction", "Upheaval"],
  48: ["Tension", "Depth", "Endeavour"], 57: ["Penetration", "Intuition", "the Clarion"],
  32: ["Maya", "Conservation", "Limitation"], 50: ["Laws", "Values", "Wishes"],
  28: ["the Unexpected", "Risks", "Alignment"], 44: ["the Four Ways", "Alertness", "Incarnation"],
  1: ["the Sphinx", "Self-Expression", "Defiance"], 43: ["Explanation", "Insight", "Dedication"],
  14: ["Contagion", "Empowering", "Uncertainty"], 34: ["the Sleeping Phoenix", "Power", "Duality"],
  9: ["Planning", "Focus", "Identification"], 5: ["Consciousness", "Habits", "Separation"],
  26: ["Rulership", "the Trickster", "Confrontation"], 11: ["Eden", "Ideas", "Education"],
  10: ["the Vessel of Love", "Behavior", "Prevention"], 58: ["Service", "Vitality", "Demands"],
  38: ["Tension", "Opposition", "Individualism"], 54: ["Penetration", "Ambition", "Cycles"],
  61: ["Maya", "Thinking", "Obscuration"], 60: ["Laws", "Limitation", "Distraction"],
  41: ["the Unexpected", "Fantasy", "the Alpha"], 19: ["the Four Ways", "Need", "Refinement"],
};

// angle: "Right Angle" | "Left Angle" | "Juxtaposition"; returns the full cross name or null.
export function crossName(personalitySunGate, angle) {
  const row = C[personalitySunGate];
  if (!row) return null;
  const idx = angle === "Left Angle" ? 2 : angle === "Juxtaposition" ? 1 : 0;
  const label = angle === "Juxtaposition" ? "Juxtaposition Cross" : `${angle} Cross`;
  return `${label} of ${row[idx]}`;
}

// The short theme label for a cross, e.g. "Dedication" or "the Sphinx".
export function crossTheme(personalitySunGate, angle) {
  const row = C[personalitySunGate];
  if (!row) return null;
  const idx = angle === "Left Angle" ? 2 : angle === "Juxtaposition" ? 1 : 0;
  return row[idx];
}

const ANGLE_PURPOSE = {
  "Right Angle": "a deeply personal path — you're here to walk it largely on your own terms, learning through your own direct experience",
  "Left Angle": "a transpersonal path — your purpose unfolds through other people, encounters and the direction you build together with them",
  "Juxtaposition": "a fixed, self-contained path — you're here to embody one very specific role, following your own distinct rhythm",
};

const lower1 = (s) => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);
const trimDot = (s) => (s || "").replace(/\.$/, "");

// A short plain-language "why you're here" paragraph, tied to the cross name.
// Pure/deterministic — needs no AI or network.
export function crossPurpose(personalitySunGate, angle) {
  const theme = crossTheme(personalitySunGate, angle);
  if (!theme) return null;
  const themeLabel = theme.startsWith("the ") ? theme : `“${theme}”`;
  const anglePurpose = ANGLE_PURPOSE[angle] || "";
  const q = quarterOf(personalitySunGate);
  const sun = trimDot(lower1(gateKeynote(personalitySunGate)));
  let p = `At its heart, your cross is about ${themeLabel}. `;
  if (anglePurpose) p += `It sets you on ${anglePurpose}. `;
  if (q) p += `It belongs to the ${q.name} — your ${q.theme.split(" — ")[0]}. `;
  if (sun) p += `Day to day, you live this out through your conscious Sun in Gate ${personalitySunGate}: ${sun}.`;
  return p.trim();
}
